// カラーボックス: 縦長の棚板複数
import { Box } from '@react-three/drei'

export default function StorageShelfMesh({ width, height, depth, position, color, isSelected }) {
    const sideThickness = width * 0.04
    const shelfThickness = height * 0.02
    const shelfCount = 4  // 3段（上下含めて4枚の棚板）

    return (
        <group>
            {/* 左側板 */}
            <Box args={[sideThickness, height, depth]} position={[-width / 2 + sideThickness / 2, position[1], 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 右側板 */}
            <Box args={[sideThickness, height, depth]} position={[width / 2 - sideThickness / 2, position[1], 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 背板 */}
            <Box args={[width - sideThickness * 2, height, depth * 0.02]} position={[0, position[1], -depth / 2 + depth * 0.01]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 棚板 */}
            {Array.from({ length: shelfCount }, (_, i) => {
                // 底板は下端に、天板は上端内側に配置
                const usableHeight = height - shelfThickness  // 上下の棚板分を除いた高さ
                const shelfY = position[1] - height / 2 + shelfThickness / 2 + (usableHeight / (shelfCount - 1)) * i
                return (
                    <Box key={i} args={[width - sideThickness * 2, shelfThickness, depth - 0.02]} position={[0, shelfY, 0]}>
                        <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
                    </Box>
                )
            })}

            {/* ワイヤーフレーム - 左側板 */}
            <Box args={[sideThickness, height, depth]} position={[-width / 2 + sideThickness / 2, position[1], 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 右側板 */}
            <Box args={[sideThickness, height, depth]} position={[width / 2 - sideThickness / 2, position[1], 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 背板 */}
            <Box args={[width - sideThickness * 2, height, depth * 0.02]} position={[0, position[1], -depth / 2 + depth * 0.01]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 棚板 */}
            {Array.from({ length: shelfCount }, (_, i) => {
                const usableHeight = height - shelfThickness
                const shelfY = position[1] - height / 2 + shelfThickness / 2 + (usableHeight / (shelfCount - 1)) * i
                return (
                    <Box key={`wire-${i}`} args={[width - sideThickness * 2, shelfThickness, depth - 0.02]} position={[0, shelfY, 0]}>
                        <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
                    </Box>
                )
            })}

            {/* 選択時のハイライト */}
            {isSelected && (
                <Box args={[width, height, depth]} position={position}>
                    <meshBasicMaterial
                        color="#fbbf24"
                        wireframe
                        opacity={0.8}
                        transparent
                    />
                </Box>
            )}
        </group>
    )
}
